import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-100 rounded-t-2xl" }
const _hoisted_2 = { class: "text-[17px] font-bold text-slate-900" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center py-16"
}
const _hoisted_4 = {
  key: 1,
  class: "overflow-y-auto px-6 py-5 flex flex-col gap-5"
}
const _hoisted_5 = { class: "bg-slate-50 rounded-xl border border-slate-100 divide-y divide-slate-100" }
const _hoisted_6 = { class: "text-xs font-medium text-slate-500 mb-1" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-slate-800 leading-relaxed break-words whitespace-pre-wrap"
}
const _hoisted_9 = {
  key: 0,
  class: "px-4 py-6 text-sm text-slate-400 italic text-center"
}
const _hoisted_10 = {
  key: 0,
  class: "text-sm text-slate-400 italic text-center py-4"
}
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_12 = {
  class: "flex flex-col items-center flex-shrink-0",
  style: {"width":"20px"}
}
const _hoisted_13 = {
  key: 0,
  class: "flex-1 border-l-2 border-dashed border-slate-200 mt-1",
  style: {"min-height":"32px"}
}
const _hoisted_14 = { class: "pb-5 flex-1" }
const _hoisted_15 = { class: "text-sm font-semibold text-slate-800" }
const _hoisted_16 = { class: "text-xs text-slate-400 mt-0.5" }
const _hoisted_17 = { class: "font-medium text-slate-500" }

import type { PengajuanBantuan } from '@/store/pengajuanBantuan.module'


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailPengajuan',
  props: {
    modelValue: { type: Boolean },
    item: {},
    loading: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const doClose = () => emit('update:modelValue', false)

function isUrl(val?: string): boolean {
  return typeof val === 'string' && /^https?:\/\//.test(val)
}

const formatDateTime = (iso?: string) => {
  if (!iso) return '-'
  return new Date(iso).toLocaleString('id-ID', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "popup" }, {
      default: _withCtx(() => [
        (__props.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4",
              onClick: doClose
            }, [
              _createElementVNode("div", {
                class: "bg-white rounded-2xl w-full max-w-[580px] shadow-2xl flex flex-col max-h-[90vh]",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", null, [
                    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-[13px] font-bold text-blue-600 mb-0.5" }, "Data Pengajuan", -1)),
                    _createElementVNode("h2", _hoisted_2, "#" + _toDisplayString(__props.item?.id), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: doClose,
                    class: "w-8 h-8 rounded-full flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-all"
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("svg", {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round"
                    }, [
                      _createElementVNode("line", {
                        x1: "18",
                        y1: "6",
                        x2: "6",
                        y2: "18"
                      }),
                      _createElementVNode("line", {
                        x1: "6",
                        y1: "6",
                        x2: "18",
                        y2: "18"
                      })
                    ], -1)
                  ]))])
                ]),
                (__props.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("div", { class: "w-8 h-8 rounded-full border-[3px] border-slate-200 border-t-blue-800 animate-spin" }, null, -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("section", null, [
                        _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-sm font-semibold text-slate-500 mb-3" }, "Data Pengajuan", -1)),
                        _createElementVNode("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(__props.item?.answersByLabel ?? {}), ([label, value]) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: label,
                              class: "px-4 py-3"
                            }, [
                              _createElementVNode("p", _hoisted_6, _toDisplayString(label), 1),
                              (isUrl(value))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: value,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    class: "inline-flex items-center gap-1.5 text-sm font-medium text-blue-700 hover:text-blue-900 hover:underline"
                                  }, [
                                    _createTextVNode(_toDisplayString(label) + " ", 1),
                                    _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                      class: "w-3.5 h-3.5 flex-shrink-0",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor",
                                      "stroke-width": "2.5"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                      })
                                    ], -1))
                                  ], 8, _hoisted_7))
                                : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(value), 1))
                            ]))
                          }), 128)),
                          (!Object.keys(__props.item?.answersByLabel ?? {}).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Tidak ada data tersedia. "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("section", null, [
                        _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-sm font-semibold text-slate-500 mb-3" }, "Riwayat Status", -1)),
                        (!__props.item?.riwayat?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Belum ada riwayat perubahan. "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.riwayat, (rw, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: rw.id,
                                  class: "flex gap-4 relative"
                                }, [
                                  _createElementVNode("div", _hoisted_12, [
                                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-3 h-3 rounded-full bg-blue-800 ring-2 ring-blue-100 flex-shrink-0 mt-0.5 z-10" }, null, -1)),
                                    (idx < __props.item.riwayat.length - 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("p", _hoisted_15, _toDisplayString(rw.keterangan), 1),
                                    _createElementVNode("p", _hoisted_16, [
                                      _createTextVNode(_toDisplayString(formatDateTime(rw.waktu)) + " · oleh ", 1),
                                      _createElementVNode("span", _hoisted_17, _toDisplayString(rw.oleh), 1)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ]))
                      ])
                    ]))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})